import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaBell } from "react-icons/fa";
// import { getFirebaseToken, onForegroundMessage } from '../../config/firebase';
import {
  IconButton,
  Tabs,
  Tab,
  Badge,
  Modal,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import "../../Assets/css/NotificationPopup.css";
// import DefaultProfileBg from "../../Assets/img/upload-image.png"
import SettingsIcon from "@mui/icons-material/Settings";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar, Button, Box, Dialog, DialogContent } from "@mui/material";
import { format } from "date-fns";
import { useQuantityContext } from "../QuantityContext";
import {
  deleteRecommendationReducer,
  getOtherProfessionalInfo,
  getRecommendationReducer,
  patchRecommendationReducer,
} from "../../Redux/Reducers/ProfileReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  deleteJobNotifications,
  getApplicants,
  getAppliedJobById,
  getAppliedJobs,
  getInterviewRounds,
  getJobNotifications,
  getOfferLetter,
  getSingleApplicantById,
  getSingleJobDesc,
  getSingleOpenJob,
  getSinglePostedJob,
  markasReadJobNotifications,
  updateJobNotifications,
} from "../../Redux/Reducers/JobReducer";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getVisitingCardReducer } from "../../Redux/Reducers/CardReducer";

const NotificationPopup = () => {
  const objectId = localStorage.getItem("objectId")?.trim();
  const [isNotifyPopupOpen, setIsNotifyPopupOpen] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const [pendingRecommendation, setpendingRecommendation] = useState([]);
  const [pendingInvitations, setpendingInvitations] = useState([]);
  const [userRequests, setUserRequests] = useState([]);
  const [contactRequests, setContactRequests] = useState([]);
  const apiKey = process.env.REACT_APP_API_KEY;
  const [unreadCount, setUnreadCount] = useState(0);
  const [activeMenu, setActiveMenu] = useState("personal");
  const { openSnackbar, handleSuccess, handleFailure, handleInfo } =
    useQuantityContext();
  const [isFullNotifyScreen, setIsFullNotifyScreen] = useState(false);
  const [showBadgeProfess, setShowBadgeProfess] = useState(false);
  const [showBadgePersonal, setShowBadgePersonal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const jobNotifications = useSelector((state) => state?.jobs?.getJobMessages) || [];
  const singleApplicant = useSelector((state) => state?.jobs?.singleApplicant?.applicant) || {};
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // console.log("singleApplicant123", singleApplicant);

  const handleMenuClick = (event, newValue) => {
    setActiveMenu(newValue);
  };

  const handleClose = () => {
    setOpenModal(false);
    setIsNotifyPopupOpen(true);
  };

  const dispatch = useDispatch();
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  // useEffect(() => {
  //   onForegroundMessage()
  //     .then((payload) => {
  //       if (payload.notification) {
  //         const { notification: { title, body } } = payload;
  //         setUnreadCount(prevCount => prevCount + 1);

  //         if (title && body) {
  //           openSnackbar(title, body);
  //         }
  //       }
  //     })
  //     .catch(err => console.log('An error occurred while retrieving foreground message.', err));

  //   // handleGetFirebaseToken();
  // }, []);

  useEffect(() => {
    dispatch(getJobNotifications());
  }, [isNotifyPopupOpen]);

  useEffect(() => { }, [isNotifyPopupOpen, pendingRequests, userRequests]);

  // const handleGetFirebaseToken = async () => {
  //   getFirebaseToken()
  //     .then((firebaseToken) => {
  //       // console.log('Firebase token: ', firebaseToken);
  //       if (firebaseToken) {
  //         axios.post('/firebasenotify/store-fcm-tokens', {
  //           user_ref_id: objectId,
  //           tokens: [firebaseToken] // Token array
  //         });
  //       }
  //     })
  //     .catch((err) => console.error('An error occurred while retrieving firebase token. ', err));
  // };

  const Notifypopup = async () => {
    setIsNotifyPopupOpen(!isNotifyPopupOpen);
    if (!isNotifyPopupOpen) {
      setUnreadCount(0);
      try {
        // const response = await axios.post('/consent/get-pending-requests', {
        //   objectId: objectId
        // });

        // setPendingRequests(response.data.pendingRequests);
        // console.log("all pending", pendingRequests);
        // handleFetchUserRequests();
        handleFetchContactRequests();
      } catch (error) {
        console.error("Error fetching pending requests:", error);
      }
    }
  };

  const handleFetchContactRequests = async () => {
    try {
      const response = await axios.get(
        "/api/v1/usercontact/connection/request", // The URL
        { headers } // Directly passing the headers object
      );
      // console.log("NOTIFICATION DATAAAAAAAAAAAaa", response)
      if (response.status === 200) {
        setContactRequests(response?.data?.contactRequests);
        setPendingRequests(response?.data?.pendingConsentRequests);
        setpendingInvitations(response?.data?.pendingGroupCardInvitations);
        setpendingRecommendation(
          response?.data?.pendingRecommendationApprovals
        );
        // console.log("TExt from the notification");
        if (
          // response.data.contactRequests.length > 0 ||
          response.data.pendingGroupCardInvitations.length > 0 ||
          response.data.contactRequests.length > 0 ||
          response.data?.pendingRecommendation?.length > 0 // Check if contactRequests has data
        ) {
          setShowBadgePersonal(true);
        } else {
          setShowBadgePersonal(false);
        }

        if (
          // Check if contactRequests has data
          response.data.pendingConsentRequests.length > 0 // Check if pendingConsentRequests is empty
          // Check if pendingGroupCardInvitations is empty
        ) {
          setShowBadgeProfess(true);
        } else {
          setShowBadgeProfess(false);
        }
      }
    } catch (error) {
      console.error("Error fetching contact requests:!!", error);
    }
  };

  // Approve a contact request
  const handleApproveContactRequest = async (requestId) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.post(
        "/api/v1/usercontact/connection/accept", // API endpoint
        { connectionId: requestId }, // Body of the POST request
        { headers } // Headers
      );

      if (response.status === 200) {
        // toast.success('Request approved successfully.');
        // setSnackbarMessage({
        //   title: 'Success',
        //   body: 'Request approved successfully.'
        // });
        // setSnackbarOpen(true);
        await handleFetchContactRequests();
        setShowBadgePersonal(false);
        // Refresh the list
      }
    } catch (error) {
      console.error("Error approving contact request:", error);
      openSnackbar("Failed to approve the request", "error");
    }
  };

  // Reject a contact request
  const handleRejectContactRequest = async (requestId) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.post(
        "/usercontact/connection/reject",
        { connectionId: requestId }, // Body of the POST request
        { headers } // Headers
      );

      if (response.status === 200) {
        handleFetchContactRequests(); // Refresh the list
        handleInfo("Request declined from the owner.");
        setShowBadgePersonal(false);
      }
    } catch (error) {
      console.error("Error rejecting contact request:", error);
      handleFailure("Failed to approve the request.", "error");
    }
  };

  const handleApprove = async (requestId, ownerId, cardName, approve) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.post("/api/v1/consent/respond-to-request", {
        ownerId,
        cardName,
        requesterId: requestId,
        approve,
      });

      // console.log("INSIDE THE NOTIFICTION", response.data.message);
      handleFetchContactRequests();
      setShowBadgeProfess(false);
      // setShowBadgePersonal(false);
      // toast.success(response.data.message);
    } catch (error) {
      console.error("Error responding to access request:", error);
      // toast.success('Failed to respond to the access request. Please try again.');
    }
  };

  const handleReject = async (id, requestId, ownerId, cardName) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.delete(
        `/api/v1/consent/reject-request/${id}`
      );

      if (response.status === 200) {
        // toast.success('Request successfully rejected.');
        // setSnackbarMessage({
        //   title: 'Success',
        //   body: 'Request successfully rejected.'
        // });
        // setSnackbarOpen(true); // Open the Snackbar
        handleInfo("Request decline from the owner.");
        handleFetchContactRequests();
        setShowBadgeProfess(false);
      }
    } catch (error) {
      console.error("Error rejecting request:", error);
    }
  };

  const handleRecommendationApprove = async (id) => {
    // const newVisibility = event.target.checked;

    try {
      setIsNotifyPopupOpen(false);
      const response = await dispatch(patchRecommendationReducer(id));
      // console.log("Responcse of the toggle visibility", response);
      if (response?.payload?.status === "SUCCESS") {
        await dispatch(getRecommendationReducer());
        handleFetchContactRequests();
        setShowBadgePersonal(false);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const handleDeleteRecommendation = async (id) => {
    // const recommendationid = recommendationId?.toString();

    try {
      setIsNotifyPopupOpen(false);
      const response = await dispatch(deleteRecommendationReducer(id));

      // console.log("response", response);
      if (response?.payload?.status === "SUCCESS") {
        await dispatch(getRecommendationReducer());
        handleFetchContactRequests(); // Refresh the list
        handleInfo("Recommendation deleted from the owner.");
        setShowBadgePersonal(false);
        // setOpenRecommendation(false);
        // setRecommendationId(null);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const handleFetchUserRequests = async () => {
    try {
      const response = await axios.post("/api/v1/consent/get-user-requests", {
        objectId,
      });
      console.log("revres", response.data.userRequests);

      setUserRequests(response.data.userRequests);
      // setShowBadge(true);
    } catch (error) {
      console.error("Error fetching user requests:", error);
    }
  };

  const handleApproveRequest = async (groupRelationId) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.post(
        "card/group-card/accept", // The API endpoint
        {
          groupRelationId, // The request body
        },
        { headers } // Use the constant headers variable here
      );

      console.log("DATA from group notifivation", response);
      if (response.status === 200) {
        // Remove the accepted request from pending requests list
        // setPendingRequests((prevRequests) => prevRequests.filter(req => req.groupId !== groupRelationId));
        handleFetchContactRequests();
        setShowBadgePersonal(false);
        console.log("Connection request accepted successfully");
      } else if (response.statusCode === 404) {
        handleFetchContactRequests();
        setShowBadgePersonal(false);
        console.log("Connection request not accepted ");
      } else {
        console.error("Error approving request:", response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Handle Decline Request by groupRelationId
  const handleDeclineRequest = async (groupRelationId) => {
    try {
      setIsNotifyPopupOpen(false);
      const response = await axios.post(
        "/card/group-card/reject",
        {
          groupRelationId,
        },
        { headers }
      );

      if (response.status === 200) {
        // Remove the rejected request from pending requests list
        // setPendingRequests((prevRequests) => prevRequests.filter(req => req.groupId !== groupRelationId));
        handleFetchContactRequests();
        // setShowBadge(false);
        console.log("Card request rejected successfully");
      } else {
        console.error("Error rejecting request:", response.data.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleOpenModal = (recommendation) => {
    setSelectedRecommendation(recommendation);
    setIsNotifyPopupOpen(false);
    setOpenModal(true);
  };

  // //lololololololololololololo
  // const handleNotificationClick = async (id, job_id, type, application_id) => {
  //   console.log("Naanuuu",id, job_id, type, application_id)
  //   try {
  //     // await dispatch(updateJobNotifications(id));

  //     const offerTypes = ['OFFER_ACCEPTED', 'OFFER_REJECTED'];
  //     const otherTypes = [
  //       'ASSIGNMENT_GIVEN',
  //       'INTERVIEW_CLEARED',
  //       'OFFER_REVOKED',
  //       'OFFER_SENT',
  //       'REJECTED',
  //       'SHORTLISTED'
  //     ];

  //     if (offerTypes.includes(type)) {
  //       navigate(`/candidateSingle-page/${application_id}`);
  //     } else if (otherTypes.includes(type)) {
  //       navigate(`/applicant-page/${job_id}`);
  //     }
  //     dispatch(getJobNotifications())

  //   } catch (error) {
  //     console.error('Error handling notification:', error);
  //   }
  // };

  const handleNotificationClick = async (id, job_id, type, application_id) => {
    const notificationId = id;
    const item = jobNotifications?.find((item) => item?.id == notificationId);

    // console.log("itemNNNNNNNN", item);

    switch (item?.type) {
      case "SHORTLISTED":
      case "ASSIGNMENT_GIVEN":
      case "INTERVIEW_SCHEDULED":
      case "REJECTED":
      case "OFFER_REVOKED":
      case "INTERVIEW_CLEARED":
      case "ASSIGNMENT_SUBMITTED":
        setLoading(true);
        dispatch(getAppliedJobs());
        dispatch(getAppliedJobById(item?.job_id))?.then(async (res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            setLoading(false);
            // readJobNotificationRes(notificationId);
            // dispatch(getSingleJobDesc(item?.job_id));
            // if (item?.purpose === "INTERVIEWER") {
            //   const response = await dispatch(getInterviewRounds(item?.application_id));
            //   // console.log("responseeee", response);
            //   dispatch(getApplicants({job_id:item?.job_id}));

            //   const res1 = await dispatch(getSingleApplicantById(item?.application_id));
            //   // console.log("ressssssss", res1, res1.payload.data.applicant.user_ref_id)
            //   if (res1?.payload?.statusCode == 200) {

            //     const applicant = res1?.payload?.data?.applicant

            //     const userRefId = applicant?.user_ref_id || applicant?.userId;
            //     if (userRefId) {
            //       const encryptedId = encodeURIComponent(
            //         CryptoJS.AES.encrypt(userRefId.toString(), "UserDetailsSecretKey").toString()
            //       );

            //       const res2 = await dispatch(getVisitingCardReducer({ encryptedId }));
            //       // if (res2?.payload?.statusCode === 200) {
            //         navigate(`/candidateSingle-page/${item?.application_id}`);
            //         setIsNotifyPopupOpen(false);
            //       // }
            //     }
            //   }
            // }
            // else {
            //   //  dispatch(getSinglePostedJob(job_id));
            //   navigate(`/applicant-page/${item?.job_id}`);
            //   setIsNotifyPopupOpen(false);
            // }

            if (item?.purpose === "INTERVIEWER" || item?.type === "ASSIGNMENT_SUBMITTED") {
              navigate(`/candidateSingle-page/${item?.application_id}`);
              setIsNotifyPopupOpen(false);
              setIsFullNotifyScreen(false);
            }
            else {
              navigate(`/applicant-page/${item?.job_id}`);
              setIsNotifyPopupOpen(false);
              setIsFullNotifyScreen(false);

            }



          } else {
            setLoading(false);
            // showMessage({
            //   message: 'Error fetching job details',
            //   type: 'danger',
            // });
          }
        });
        break;

      case "OFFER_SENT":
      case "OFFER_REVISED":
        setLoading(true);
        dispatch(getOfferLetter(item?.application_id))?.then((res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            setLoading(false);
            // readJobNotificationRes(notificationId);
            // dispatch(getSingleJobDesc(item?.job_id));
            navigate(`/applicant-page/${item?.job_id}`);
            setIsNotifyPopupOpen(false);
            setIsFullNotifyScreen(false);
          } else {
            setLoading(false);
            // showMessage({
            //   message: 'Error fetching offer letter details',
            //   type: 'danger',
            // });
          }
        });


      case "INTERVIEW_DELETED":
        setLoading(true);
        try {
          // Await both API calls in sequence
          await dispatch(getAppliedJobById(item?.job_id));
          const res = await dispatch(getInterviewRounds(item?.application_id));
          if (res?.meta?.requestStatus === "fulfilled") {
            setLoading(false);
            //  dispatch(getSingleJobDesc(item?.job_id));
            // navigate(`/applicant-page/${item?.job_id}`);
            // const res = await dispatch(getSingleApplicantById(item?.application_id));

            // if(res?.statusCode == 200){

            // }

            // const encryptedId = encodeURIComponent(
            //         CryptoJS.AES.encrypt(
            //           singleApplicant.user_ref_id.toString(),
            //           "UserDetailsSecretKey"
            //         ).toString()
            //       );
            // dispatch(getVisitingCardReducer({ encryptedId }));
            // navigate(`/candidateSingle-page/${item?.application_id}`);
            setIsNotifyPopupOpen(false);
            setIsFullNotifyScreen(false);
          } else {
            setLoading(false);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching interview details:", error);
        }
        break;

      case "OFFER_ACCEPTED":
      case "OFFER_REJECTED":
        setLoading(true);
        // dispatch(getSingleJobDesc(item?.job_id));s
        dispatch(getSingleApplicantById(item?.application_id));
        dispatch(getOtherProfessionalInfo(item?.recipient_id)).then((res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            setLoading(false);
            // readJobNotificationRes(notification?.id);
            // navigation.navigate('CandidateProfile');
            navigate(`/candidateSingle-page/${item?.application_id}`);
            setIsNotifyPopupOpen(false);
            setIsFullNotifyScreen(false);
          } else {
            setLoading(false);
            // showMessage({
            //   message: 'Error fetching applicant details',
            //   type: 'danger',
            // });
          }
        });
        break;

      case "JOB_INVITE":
        setLoading(true);
        dispatch(getSingleOpenJob({ id: item?.job_id }))?.then((res) => {
          if (res?.meta?.requestStatus === "fulfilled") {
            setLoading(false);
            // readJobNotificationRes(notification?.id);
            // navigation.navigate('JobDescriptionApplicant');
          } else {
            setLoading(false);
            // showMessage({
            //   message: 'Error fetching job details',
            //   type: 'danger',
            // });
          }
        });
        break;

      case "ASSIGNMENT_SUBMITTED":
        setLoading(true);
        dispatch(getInterviewRounds({ id: item?.application_id }))?.then(
          (res) => {
            if (res?.meta?.requestStatus === "fulfilled") {
              setLoading(false);
              // readJobNotificationRes(notification?.id);
              // navigation.navigate('RecruiterInterviewRounds');
              navigate(`/candidateSingle-page/${item?.applicant_id}`);
              setIsNotifyPopupOpen(false);
              setIsFullNotifyScreen(false);
            } else {
              setLoading(false);
              // showMessage({
              //   message: 'Error fetching interview details',
              //   type: 'danger',
              // });
            }
          }
        );
        break;

      default:
        // showMessage({message: 'Invalid notification type.'});
        // readJobNotificationRes(item?.id);
        break;
    }
  };

  // const handleJobNotification = (notification) => {
  //   const notificationId = notification?.id;
  //   const item = jobNotifications?.find(
  //     (item) => item?.id == notificationId,
  //   );

  //   switch (item?.type) {
  //     case 'SHORTLISTED':
  //     case 'REJECTED':
  //     case 'OFFER_REVOKED':
  //     case 'INTERVIEW_CLEARED':
  //       setLoading(true);
  //       dispatch(getSingleAppliedJob({id: item?.job_id}))?.then((res) => {
  //         if (res?.meta?.requestStatus === 'fulfilled') {
  //           setLoading(false);
  //           readJobNotificationRes(notification?.id);
  //           navigation.navigate('AppliedJobDescription');
  //         } else {
  //           setLoading(false);
  //           showMessage({
  //             message: 'Error fetching job details',
  //             type: 'danger',
  //           });
  //         }
  //       });
  //       break;

  //     case 'OFFER_SENT':
  //     case 'OFFER_REVISED':
  //       setLoading(true);
  //       dispatch(getOfferLetter({id: item?.application_id}))?.then(
  //         (res) => {
  //           if (res?.meta?.requestStatus === 'fulfilled') {
  //             setLoading(false);
  //             readJobNotificationRes(notification?.id);
  //             navigation.navigate('ViewOfferLetterScreen');
  //           } else {
  //             setLoading(false);
  //             showMessage({
  //               message: 'Error fetching offer letter details',
  //               type: 'danger',
  //             });
  //           }
  //         },
  //       );
  //       break;

  //     case 'ASSIGNMENT_GIVEN':
  //     case 'INTERVIEW_SCHEDULED':
  //     case 'INTERVIEW_DELETED':
  //       setLoading(true);
  //       dispatch(getSingleAppliedJob({id: item?.job_id}));
  //       dispatch(getInterviewRounds({id: item?.application_id}))?.then(
  //         (res) => {
  //           if (res?.meta?.requestStatus === 'fulfilled') {
  //             setLoading(false);
  //             readJobNotificationRes(notification?.id);
  //             navigation.navigate('ApplicantInterviewRounds');
  //           } else {
  //             setLoading(false);
  //             showMessage({
  //               message: 'Error fetching interview details',
  //               type: 'danger',
  //             });
  //           }
  //         },
  //       );
  //       break;

  //     case 'OFFER_ACCEPTED':
  //     case 'OFFER_REJECTED':
  //       setLoading(true);
  //       dispatch(getSinglePostedJob({id: item?.job_id}));
  //       dispatch(getSingleApplicant({id: item?.application_id}));
  //       dispatch(getOtherProfessionalInfo({userId: item?.applicant_id})).then(
  //         (res) => {
  //           if (res?.meta?.requestStatus === 'fulfilled') {
  //             setLoading(false);
  //             readJobNotificationRes(notification?.id);
  //             navigation.navigate('CandidateProfile');
  //           } else {
  //             setLoading(false);
  //             showMessage({
  //               message: 'Error fetching applicant details',
  //               type: 'danger',
  //             });
  //           }
  //         },
  //       );
  //       break;

  //     case 'JOB_INVITE':
  //       setLoading(true);
  //       dispatch(getSingleOpenJob({id: item?.job_id}))?.then((res) => {
  //         if (res?.meta?.requestStatus === 'fulfilled') {
  //           setLoading(false);
  //           readJobNotificationRes(notification?.id);
  //           navigation.navigate('JobDescriptionApplicant');
  //         } else {
  //           setLoading(false);
  //           showMessage({
  //             message: 'Error fetching job details',
  //             type: 'danger',
  //           });
  //         }
  //       });
  //       break;

  //     case 'ASSIGNMENT_SUBMITTED':
  //       setLoading(true);
  //       dispatch(getInterviewRounds({id: item?.application_id}))?.then(
  //         (res) => {
  //           if (res?.meta?.requestStatus === 'fulfilled') {
  //             setLoading(false);
  //             readJobNotificationRes(notification?.id);
  //             navigation.navigate('RecruiterInterviewRounds');
  //           } else {
  //             setLoading(false);
  //             showMessage({
  //               message: 'Error fetching interview details',
  //               type: 'danger',
  //             });
  //           }
  //         },
  //       );
  //       break;

  //     default:
  //       showMessage({message: 'Invalid notification type.'});
  //       readJobNotificationRes(item?.id);
  //       break;
  //   }
  // };

  const handleMarkasReadClick = () => {
    console.log("markasReadJobNotifications");
    dispatch(markasReadJobNotifications());
  };

  const handleNotificationDelete = async (id) => {
    try {
      setIsNotifyPopupOpen(false);
      const payload = {
        ids: [id],
        deleteAll: false
      };
      console.log("meraDelete", payload)
      const response = await dispatch(deleteJobNotifications(payload));
      if (response?.payload?.status === "SUCCESS") {
        handleFetchContactRequests();
        openSnackbar("Notification deleted successfully.");
        getJobNotifications()
        setShowBadgePersonal(false);

      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  }

  return (
    <>
      <div className="icon" onClick={Notifypopup}>
        <FaBell className="icon-color" />
        {unreadCount > 0 && (
          <span className="badge bg-danger bell-design">{unreadCount}</span>
        )}
      </div>

      {isNotifyPopupOpen && (
        <div className="notification-popup">
          <div className="ps-3 pe-2 pt-3 pb-2">
            <div className="d-flex align-items-center justify-content-between">
              <h6
                className="group_permissions_subtitle fw-bold"
                style={{ fontSize: "20px" }}
              >
                Notifications
              </h6>
              <div className="d-flex align-items-center">
                <SettingsIcon className="icon-color" />
                <IconButton className="ms-2" onClick={Notifypopup}>
                  <CloseIcon className="icon-color" />
                </IconButton>
              </div>
            </div>
          </div>
          <div
            className="text-end pe-3 color-blue pointer"
            onClick={handleMarkasReadClick}
          >
            Mark all as read
          </div>

          <div
            className=""
            style={{
              /*maxHeight: `${availableHeight1}px`,*/ overflowY: "auto",
              scrollbarWidth: "none",
            }}
          >
            <div className="menu">
              <Tabs
                value={activeMenu}
                onChange={handleMenuClick}
                aria-label="Profile Tabs"
                className="custom-profile-tabs"
                selectionFollowsFocus
              >
                {/* <Tab
                  // label="Personal"
                  value="personal"
                  className='ms-2 mt-2'
                  label={
                    showBadgePersonal ? (
                      <Badge color="error" variant="dot" style={{ margin: "5px" }} badgeContent=" ">
                        Personal
                      </Badge>
                    ) : (
                      "Personal"
                    )
                  }
                // onClick={handlePersonalTabClick}
                /> */}

                <Tab
                  value="personal"
                  className="ms-2"
                  sx={{
                    marginRight: "20px",
                  }}
                  label={
                    showBadgePersonal ? (
                      <Badge
                        color="error"
                        variant="dot"
                        badgeContent=" "
                        sx={{
                          "& .MuiBadge-dot": {
                            width: "12px", // Increase badge size
                            height: "12px",
                            borderRadius: "50%", // Increase badge size
                          },
                          // marginLeft: '100px',
                          // Move badge slightly to the left
                        }}
                      >
                        Personal
                      </Badge>
                    ) : (
                      "Personal"
                    )
                  }
                // onClick={handlePersonalTabClick}
                />

                <Tab
                  // label="Professional"
                  label={
                    showBadgeProfess ? (
                      <Badge
                        color="error"
                        variant="dot"
                        badgeContent=" "
                        sx={{
                          "& .MuiBadge-dot": {
                            width: "12px", // Increase badge size
                            height: "12px",
                            borderRadius: "50%",
                          },
                        }}
                      >
                        Professional
                      </Badge>
                    ) : (
                      "Professional"
                    )
                  }
                  value="professional"
                />
                {/* <Tab
                  label="Financial"
                  value="financial"
                />
                <Tab
                  label="General"
                  value="General"
                /> */}
              </Tabs>
            </div>
            <div className="content-for-that-link">
              {activeMenu === "personal" && (
                <>
                  {pendingRequests
                    ?.filter((request) => request.cardName === "Personal")
                    .map((request) => {
                      const timestamp = request.timestamp;
                      let formattedDate = "Invalid Date";

                      // Ensure that the timestamp is defined and valid
                      if (timestamp) {
                        const date = new Date(timestamp);
                        if (!isNaN(date.getTime())) {
                          // Use "MMM" for abbreviated month
                          formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                        }
                      }

                      return (
                        <Box
                          key={request?.id} // Unique key
                          className="p-3"
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            gap: 2,
                            width: "100%",
                            borderBottom: "1px solid #DDE0E6",
                          }}
                        >
                          <Avatar
                            alt={request.viewerfName}
                            src={request.viewerUrl}
                            sx={{
                              width: 40,
                              height: 40,
                              border: "2px solid #e0e0e0",
                            }}
                          />
                          <Box sx={{ flexGrow: 1 }}>
                            <div className="d-flex align-items-center gap-2">
                              <div
                                style={{ fontSize: "14px", color: "#212121" }}
                              >
                                {request.viewerfName} {request.viewerlName}
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#8059FF" }}
                              >
                                Private
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#169F23E5" }}
                              >
                                Consent
                              </div>
                            </div>
                            <div className="group_permissiions_options mt-1">
                              {request.viewerfName} wants to view your{" "}
                              {request?.cardName} card. Respond to this
                            </div>
                            <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                              <Button
                                variant="outlined"
                                className="Button-grey"
                                size="small"
                                onClick={() =>
                                  handleReject(
                                    request?.id || request?._id,
                                    request.requesterId,
                                    request.ownerId,
                                    request.cardName
                                  )
                                }
                              >
                                Decline
                              </Button>
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#0044C6" }}
                                className="btn btn-primary"
                                size="small"
                                onClick={() =>
                                  handleApprove(
                                    request.requesterId,
                                    request.ownerId,
                                    request.cardName,
                                    true
                                  )
                                }
                              >
                                Approve
                              </Button>
                            </div>
                            <div
                              className="mt-2"
                              style={{ fontSize: "14px", color: "#00000061" }}
                            >
                              {formattedDate}
                            </div>
                          </Box>
                        </Box>
                      );
                    })}

                  {contactRequests?.map((request) => {
                    const timestamp = request.modifiedAt;
                    let formattedDateContact = "Invalid Date";

                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        formattedDateContact = format(
                          date,
                          "MMM dd, yyyy 'at' h a"
                        );
                      }
                    }
                    return (
                      <Box
                        key={request.id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.firstName}
                          src={request.profile_url}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        >
                          {request.firstName.charAt(0).toUpperCase()}
                        </Avatar>
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ fontSize: "14px", color: "#212121" }}>
                              {request.firstName} {request.lastName}
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#8059FF" }}
                            >
                              Private
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#0582D5E5" }}
                            >
                              Connect
                            </div>
                          </div>

                          <div className="group_permissiions_options mt-1">
                            {request.firstName} {request.lastName} wants to
                            connect with you. Respond to this.
                          </div>

                          <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() =>
                                handleRejectContactRequest(request.id)
                              }
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#0044C6" }}
                              className="btn btn-primary"
                              size="small"
                              onClick={() =>
                                handleApproveContactRequest(request.id)
                              }
                            >
                              Approve
                            </Button>
                          </div>

                          {/* Render the formatted date */}
                          <div
                            className="mt-2"
                            style={{ fontSize: "14px", color: "#00000061" }}
                          >
                            {formattedDateContact}
                          </div>
                        </Box>
                      </Box>
                    );
                  })}
                  {/* Render Pending Invitations */}
                  {pendingInvitations?.map((invitation) => {
                    const timestamp = invitation.timestamp;
                    let formattedDate = "Invalid Date";

                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    return (
                      <Box
                        key={invitation._id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={invitation.requesterFirstName}
                          src={invitation.requesterUrl}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ fontSize: "14px", color: "#212121" }}>
                              {invitation.requesterFirstName}{" "}
                              {invitation.requesterLastName}
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#169F23E5" }}
                            >
                              Consent
                            </div>
                          </div>
                          <div className="group_permissiions_options mt-1">
                            {invitation.requesterFirstName} wants you to join
                            their Group Card. Respond to this
                          </div>
                          <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() =>
                                handleDeclineRequest(invitation.groupId)
                              }
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#0044C6" }}
                              className="btn btn-primary"
                              size="small"
                              onClick={() =>
                                handleApproveRequest(invitation.groupId)
                              }
                            >
                              Approve
                            </Button>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "14px", color: "#00000061" }}
                          >
                            {formattedDate}
                          </div>
                        </Box>
                      </Box>
                    );
                  })}
                </>
              )}
              {activeMenu === "professional" && (
                <>
                  {pendingRequests.map((request) => {
                    const timestamp = request.timestamp;
                    let formattedDate = "Invalid Date";

                    // Ensure that the timestamp is defined and valid
                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        // Use "MMM" for abbreviated month
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    // console.log("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNot comimg");
                    return (
                      <Box
                        key={request?.id} // Unique key
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.viewerfName}
                          src={request.viewerUrl}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ fontSize: "14px", color: "#212121" }}>
                              {request.viewerfName} {request.viewerlName}
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#8059FF" }}
                            >
                              Private
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#169F23E5" }}
                            >
                              Consent
                            </div>
                          </div>
                          <div className="group_permissiions_options mt-1">
                            {request.viewerfName} wants to view your{" "}
                            {request?.cardName} card. Respond to this
                          </div>
                          <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() =>
                                handleReject(
                                  request?.id || request?._id,
                                  request.requesterId,
                                  request.ownerId,
                                  request.cardName
                                )
                              }
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#0044C6" }}
                              className="btn btn-primary"
                              size="small"
                              onClick={() =>
                                handleApprove(
                                  request.requesterId,
                                  request.ownerId,
                                  request.cardName,
                                  true
                                )
                              }
                            >
                              Approve
                            </Button>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "14px", color: "#00000061" }}
                          >
                            {formattedDate}
                          </div>
                        </Box>
                      </Box>
                    );
                  })}

                  {pendingRecommendation?.map((request) => {
                    const timestamp = request?.creationDate;
                    let formattedDate = "Invalid Date";

                    // Ensure that the timestamp is defined and valid
                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        // Use "MMM" for abbreviated month
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    // console.log("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNot comimg");
                    return (
                      <Box
                        key={request?._id} // Unique key
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.viewerfName}
                          src={request?.profilePic}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ fontSize: "14px", color: "#212121" }}>
                              {request?.firstName} {request?.lastName}
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#8059FF" }}
                            >
                              Private
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#169F23E5" }}
                            >
                              Consent
                            </div>
                          </div>
                          <div className="group_permissiions_options mt-1">
                            {request?.firstName} {request?.lastName} sent the
                            Recommendation Message.{" "}
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() => handleOpenModal(request)}
                            >
                              Read the Recommendation.
                            </Button>
                          </div>
                          <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() =>
                                handleDeleteRecommendation(request?.id)
                              }
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#0044C6" }}
                              className="btn btn-primary"
                              size="small"
                              onClick={() =>
                                handleRecommendationApprove(request?.id)
                              }
                            >
                              Approve
                            </Button>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "14px", color: "#00000061" }}
                          >
                            {formattedDate}
                          </div>
                        </Box>
                      </Box>
                    );
                  })}

                  {jobNotifications?.map((notification) => {
                    const {
                      id,
                      company_logo,
                      company_name,
                      role,
                      message,
                      created_at,
                      job_id,
                      title,
                      type,
                      application_id,
                    } = notification;

                    const date = new Date(created_at);
                    const formattedDate = isNaN(date.getTime())
                      ? "Invalid Date"
                      : format(date, "MMM dd, yyyy 'at' h a");

                    return (
                      <Box
                        key={id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={company_name}
                          src={company_logo || "/default-company-logo.png"}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <Typography
                              fontSize="14px"
                              fontWeight={600}
                              color="#212121"
                            >
                              {company_name}
                            </Typography>
                            <div
                              className="typeOfNoti-color"
                              style={{
                                backgroundColor: "#169F23E5",
                                color: "#fff",
                                padding: "2px 8px",
                                borderRadius: 4,
                                fontSize: "12px",
                              }}
                            >
                              {type.replaceAll("_", " ")}
                            </div>
                          </div>

                          <Typography
                            className="group_permissiions_options mt-1"
                            fontSize="14px"
                            color="text.primary"
                          >
                            {message}
                          </Typography>

                          <Box className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#0044C6",
                                textTransform: "none",
                              }}
                              size="small"
                              onClick={() =>
                                handleNotificationClick(
                                  id,
                                  job_id,
                                  type,
                                  application_id
                                )
                              }
                            >
                              OPEN
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "red",
                                textTransform: "none",
                              }}
                              size="small"
                              onClick={() =>
                                handleNotificationDelete(id)
                              }
                            >
                              DELETE
                            </Button>
                          </Box>

                          <Typography
                            className="mt-2"
                            fontSize="13px"
                            color="#00000061"
                          >
                            {formattedDate}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </>
              )}
              {/* {activeMenu === 'financial' && (
                <>
                  "Financial"
                </>
              )}
              {activeMenu === 'ppf_score' && (
                <>
                  "PPF"
                </>
              )} */}
              <div
                className="text-end py-3 pe-3"
                style={{ backgroundColor: "#0044C60A" }}
                onClick={() => {
                  setIsNotifyPopupOpen(false);
                  setIsFullNotifyScreen(true);
                }}
              >
                Show All Notifications
              </div>
            </div>
          </div>
        </div>
      )}

      <Dialog
        className="controlled-width-dialog"
        open={isFullNotifyScreen}
        onClose={() => {
          setIsFullNotifyScreen(false);
        }}
      >
        <Box style={{ minWidth: "900px", maxWidth: "1100px" }}>
          <div className="ps-3 pe-2 pt-3 pb-2">
            <div className="d-flex align-items-center justify-content-between">
              <h6
                className="group_permissions_subtitle fw-bold"
                style={{ fontSize: "20px" }}
              >
                Notifications
              </h6>
              <div className="d-flex align-items-center">
                <SettingsIcon className="icon-color pointer" />
                <IconButton
                  className="ms-2"
                  onClick={() => {
                    setIsFullNotifyScreen(false);
                  }}
                >
                  <CloseIcon className="icon-color" />
                </IconButton>
              </div>
            </div>
          </div>
          <div className="menu flex-center-between w-100">
            <Tabs
              value={activeMenu}
              onChange={handleMenuClick}
              aria-label="Profile Tabs"
              className="custom-profile-tabs"
              selectionFollowsFocus
            >
              <Tab
                label="Personal"
                value="personal"
                className="ms-2"
              // onClick={handlePersonalTabClick}
              />
              <Tab label="Professional" value="professional" />
              {/* <Tab
                label="Financial"
                value="financial"
              />
              <Tab
                label="General"
                value="General"
              /> */}
            </Tabs>
            <div
              className="text-end pe-3 color-blue pointer"
              onClick={handleMarkasReadClick}
            >
              Mark all as read
            </div>
          </div>

          <DialogContent
            className="m-0 p-0"
            style={{
              scrollbarWidth: "thin",
              maxHeight: "350px",
              overflowY: "auto",
            }}
          >
            <div className="content-for-that-link">
              {activeMenu === "personal" && (
                <>
                  {/* {pendingRequests?.map(request => { */}
                  {pendingRequests
                    ?.filter((request) => request.cardName === "Personal")
                    .map((request) => {
                      const timestamp = request.timestamp;
                      let formattedDate = "Invalid Date";

                      // Ensure that the timestamp is defined and valid
                      if (timestamp) {
                        const date = new Date(timestamp);
                        if (!isNaN(date.getTime())) {
                          // Use "MMM" for abbreviated month
                          formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                        }
                      }
                      return (
                        <Box
                          key={request?._id} // Unique key
                          className="p-3"
                          sx={{
                            display: "flex",
                            alignItems: "start",
                            gap: 2,
                            width: "100%",
                            borderBottom: "1px solid #DDE0E6",
                          }}
                        >
                          <Avatar
                            alt={request.viewerfName}
                            src={request.viewerUrl}
                            sx={{
                              width: 40,
                              height: 40,
                              border: "2px solid #e0e0e0",
                            }}
                          />
                          <Box
                            className="flex-center-between"
                            sx={{ flexGrow: 1 }}
                          >
                            <div className="d-flex flex-column">
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  style={{ fontSize: "14px", color: "#212121" }}
                                >
                                  {request.viewerfName} {request.viewerlName}
                                </div>
                                <div
                                  className="typeOfNoti-color"
                                  style={{ backgroundColor: "#8059FF" }}
                                >
                                  Private
                                </div>
                                <div
                                  className="typeOfNoti-color"
                                  style={{ backgroundColor: "#169F23E5" }}
                                >
                                  Consent
                                </div>
                              </div>
                              <div className="group_permissiions_options mt-1">
                                {request.viewerfName} wants to view your{" "}
                                {request?.cardName} card. Respond to this
                              </div>
                            </div>
                            <div className="flex-center-between gap-3">
                              <div
                                className="mt-2"
                                style={{ fontSize: "14px", color: "#00000061" }}
                              >
                                {formattedDate}
                              </div>
                              <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                                <Button
                                  variant="outlined"
                                  className="Button-grey"
                                  size="small"
                                  onClick={() =>
                                    handleReject(
                                      request?.id || request?._id,
                                      request.requesterId,
                                      request.ownerId,
                                      request.cardName
                                    )
                                  }
                                >
                                  Decline
                                </Button>
                                <Button
                                  variant="contained"
                                  sx={{ backgroundColor: "#0044C6" }}
                                  className="btn btn-primary"
                                  size="small"
                                  onClick={() =>
                                    handleApprove(
                                      request.requesterId,
                                      request.ownerId,
                                      request.cardName,
                                      true
                                    )
                                  }
                                >
                                  Approve
                                </Button>
                              </div>
                            </div>
                          </Box>
                        </Box>
                      );
                    })}

                  {contactRequests?.map((request) => {
                    const timestamp = request.modifiedAt;
                    let formattedDateContact = "Invalid Date";

                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        formattedDateContact = format(
                          date,
                          "MMM dd, yyyy 'at' h a"
                        );
                      }
                    }
                    return (
                      <Box
                        key={request.id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.firstName}
                          src={request.profile_url}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        >
                          {request.firstName.charAt(0).toUpperCase()}
                        </Avatar>
                        <Box
                          className="flex-center-between"
                          sx={{ flexGrow: 1 }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2">
                              <div
                                style={{ fontSize: "14px", color: "#212121" }}
                              >
                                {request.firstName} {request.lastName}
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#8059FF" }}
                              >
                                Private
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#0582D5E5" }}
                              >
                                Connect
                              </div>
                            </div>

                            <div className="group_permissiions_options mt-1">
                              {request.firstName} {request.lastName} wants to
                              connect with you. Respond to this.
                            </div>
                          </div>

                          <div className="flex-center-between gap-3">
                            <div
                              className="mt-2"
                              style={{ fontSize: "14px", color: "#00000061" }}
                            >
                              {formattedDateContact}
                            </div>
                            <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                              <Button
                                variant="outlined"
                                className="Button-grey"
                                size="small"
                                onClick={() =>
                                  handleRejectContactRequest(request.id)
                                }
                              >
                                Decline
                              </Button>
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#0044C6" }}
                                className="btn btn-primary"
                                size="small"
                                onClick={() =>
                                  handleApproveContactRequest(request.id)
                                }
                              >
                                Approve
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Box>
                    );
                  })}

                  {pendingInvitations?.map((invitation) => {
                    const timestamp = invitation.timestamp;
                    let formattedDate = "Invalid Date";

                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    return (
                      <Box
                        key={invitation._id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={invitation.requesterFirstName}
                          src={invitation.requesterUrl}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box
                          className="flex-center-between"
                          sx={{ flexGrow: 1 }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2">
                              <div
                                style={{ fontSize: "14px", color: "#212121" }}
                              >
                                {invitation.requesterFirstName}{" "}
                                {invitation.requesterLastName}
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#169F23E5" }}
                              >
                                Consent
                              </div>
                            </div>
                            <div className="group_permissiions_options mt-1">
                              {invitation.requesterFirstName} wants you to join
                              their Group Card. Respond to this
                            </div>
                          </div>

                          <div className="flex-center-between gap-3">
                            <div
                              className="mt-2"
                              style={{ fontSize: "14px", color: "#00000061" }}
                            >
                              {formattedDate}
                            </div>
                            <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                              <Button
                                variant="outlined"
                                className="Button-grey"
                                size="small"
                                onClick={() =>
                                  handleDeclineRequest(invitation.groupId)
                                }
                              >
                                Decline
                              </Button>
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#0044C6" }}
                                className="btn btn-primary"
                                size="small"
                                onClick={() =>
                                  handleApproveRequest(invitation.groupId)
                                }
                              >
                                Approve
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Box>
                    );
                  })}
                </>
              )}
              {activeMenu === "professional" && (
                <>
                  {pendingRequests.map((request) => {
                    const timestamp = request.timestamp;
                    let formattedDate = "Invalid Date";

                    // Ensure that the timestamp is defined and valid
                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        // Use "MMM" for abbreviated month
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    return (
                      <Box
                        key={request?.id} // Unique key
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.viewerfName}
                          src={request.viewerUrl}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box
                          className="flex-center-between"
                          sx={{ flexGrow: 1 }}
                        >
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-2">
                              <div
                                style={{ fontSize: "14px", color: "#212121" }}
                              >
                                {request.viewerfName} {request.viewerlName}
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#8059FF" }}
                              >
                                Private
                              </div>
                              <div
                                className="typeOfNoti-color"
                                style={{ backgroundColor: "#169F23E5" }}
                              >
                                Consent
                              </div>
                            </div>
                            <div className="group_permissiions_options mt-1">
                              {request.viewerfName} wants to view your{" "}
                              {request?.cardName} card. Respond to this
                            </div>
                          </div>
                          <div className="flex-center-between gap-3">
                            <div
                              className="mt-2"
                              style={{ fontSize: "14px", color: "#00000061" }}
                            >
                              {formattedDate}
                            </div>
                            <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                              <Button
                                variant="outlined"
                                className="Button-grey"
                                size="small"
                                onClick={() =>
                                  handleReject(
                                    request?.id || request?._id,
                                    request.requesterId,
                                    request.ownerId,
                                    request.cardName
                                  )
                                }
                              >
                                Decline
                              </Button>
                              <Button
                                variant="contained"
                                sx={{ backgroundColor: "#0044C6" }}
                                className="btn btn-primary"
                                size="small"
                                onClick={() =>
                                  handleApprove(
                                    request.requesterId,
                                    request.ownerId,
                                    request.cardName,
                                    true
                                  )
                                }
                              >
                                Approve
                              </Button>
                            </div>
                          </div>
                        </Box>
                      </Box>
                    );
                  })}

                  {pendingRecommendation?.map((request) => {
                    const timestamp = request?.creationDate;
                    let formattedDate = "Invalid Date";

                    // Ensure that the timestamp is defined and valid
                    if (timestamp) {
                      const date = new Date(timestamp);
                      if (!isNaN(date.getTime())) {
                        // Use "MMM" for abbreviated month
                        formattedDate = format(date, "MMM dd, yyyy 'at' h a");
                      }
                    }
                    // console.log("NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNot comimg");
                    return (
                      <Box
                        key={request?.id} // Unique key
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={request.viewerfName}
                          src={request?.profilePic}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ fontSize: "14px", color: "#212121" }}>
                              {request?.firstName} {request?.lastName}
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#8059FF" }}
                            >
                              Private
                            </div>
                            <div
                              className="typeOfNoti-color"
                              style={{ backgroundColor: "#169F23E5" }}
                            >
                              Consent
                            </div>
                          </div>
                          <div className="group_permissiions_options mt-1">
                            {request?.firstName} {request?.lastName} sent the
                            Recommendation Message.{" "}
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() => handleOpenModal(request)}
                            >
                              Read the Recommendation.
                            </Button>
                          </div>
                          <div className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="outlined"
                              className="Button-grey"
                              size="small"
                              onClick={() =>
                                handleDeleteRecommendation(request?.id)
                              }
                            >
                              Decline
                            </Button>
                            <Button
                              variant="contained"
                              sx={{ backgroundColor: "#0044C6" }}
                              className="btn btn-primary"
                              size="small"
                              onClick={() =>
                                handleRecommendationApprove(request?.id)
                              }
                            >
                              Approve
                            </Button>
                          </div>
                          <div
                            className="mt-2"
                            style={{ fontSize: "14px", color: "#00000061" }}
                          >
                            {formattedDate}
                          </div>
                        </Box>
                      </Box>
                    );
                  })}
                  {jobNotifications?.map((notification) => {
                    const {
                      id,
                      company_logo,
                      company_name,
                      role,
                      message,
                      created_at,
                      job_id,
                      title,
                      type,
                      application_id,
                    } = notification;

                    const date = new Date(created_at);
                    const formattedDate = isNaN(date.getTime())
                      ? "Invalid Date"
                      : format(date, "MMM dd, yyyy 'at' h a");

                    return (
                      <Box
                        key={id}
                        className="p-3"
                        sx={{
                          display: "flex",
                          alignItems: "start",
                          gap: 2,
                          width: "100%",
                          borderBottom: "1px solid #DDE0E6",
                        }}
                      >
                        <Avatar
                          alt={company_name}
                          src={company_logo || "/default-company-logo.png"}
                          sx={{
                            width: 40,
                            height: 40,
                            border: "2px solid #e0e0e0",
                          }}
                        />
                        <Box sx={{ flexGrow: 1 }}>
                          <div className="d-flex align-items-center gap-2">
                            <Typography
                              fontSize="14px"
                              fontWeight={600}
                              color="#212121"
                            >
                              {company_name}
                            </Typography>
                            <div
                              className="typeOfNoti-color"
                              style={{
                                backgroundColor: "#169F23E5",
                                color: "#fff",
                                padding: "2px 8px",
                                borderRadius: 4,
                                fontSize: "12px",
                              }}
                            >
                              {type.replaceAll("_", " ")}
                            </div>
                          </div>

                          <Typography
                            className="group_permissiions_options mt-1"
                            fontSize="14px"
                            color="text.primary"
                          >
                            {message}
                          </Typography>

                          <Box className="mt-2 d-flex align-items-center justify-content-start gap-2">
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "#0044C6",
                                textTransform: "none",
                              }}
                              size="small"
                              onClick={() =>
                                handleNotificationClick(
                                  id,
                                  job_id,
                                  type,
                                  application_id
                                )
                              }
                            >
                              OPEN
                            </Button>
                            <Button
                              variant="contained"
                              sx={{
                                backgroundColor: "red",
                                textTransform: "none",
                              }}
                              size="small"
                              onClick={() =>
                                handleNotificationClick(
                                  id,
                                  job_id,
                                  type,
                                  application_id
                                )
                              }
                            >
                              DELETE
                            </Button>
                          </Box>

                          <Typography
                            className="mt-2"
                            fontSize="13px"
                            color="#00000061"
                          >
                            {formattedDate}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  })}
                </>
              )}
              {/* {activeMenu === 'financial' && (
                <>
                  "Financial"
                </>
              )}
              {activeMenu === 'ppf_score' && (
                <>
                  "PPF"
                </>
              )} */}
            </div>
          </DialogContent>
        </Box>
      </Dialog>

      <Modal open={openModal} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            textAlign: "center",
            width: "500px",
          }}
        >
          <div
            className="py-1 d-flex flex-row justify-content-between align-items-center"
            style={{ borderBottom: "1px solid #DDE0E6" }}
          >
            <Typography variant="h6">Recommendation Message</Typography>
            <IconButton className="ms-2" onClick={handleClose}>
              <CloseIcon className="icon-color" />
            </IconButton>
          </div>

          {selectedRecommendation ? (
            <Box sx={{ textAlign: "start", mt: 2 }}>
              {/* <Typography variant="h6">{selectedRecommendation.firstName} {selectedRecommendation.lastName}</Typography> */}
              <Typography>{selectedRecommendation.text}</Typography>
            </Box>
          ) : (
            <Typography>No message selected</Typography>
          )}
        </Box>
      </Modal>
      <div></div>
    </>
  );
};

export default NotificationPopup;
